<template>
  <div class="hamkaranEmailMaker" style="background:#293039;min-height: calc(100vh - 155px);">
    <div id="Em_titile">
      <i class="fa-solid fa-chevron-right back" @click="$router.push({ path: '/admin/template/whatsapp_list' });"></i>
      <h1 style="display: inline-block;">برنامه ساخت قالب پیام‌های واتساپ</h1>
      <span style="float: left;">
        <CInput
          :placeholder="$t('whatsappTemplate.title')"
          style="display: inline-block;padding-left: 9px;"
          v-model="whatsapp.name"
        />
        <CButton :disabled="whatsapp.name == null" variant="outline" @click="storeData" color="light">
          <CSpinner v-if="storeLoading" tag="span" size="sm" />
          <CIcon v-if="!storeLoading" class="top_menu" name="cil-save" />
          <span>
            ذخیره قالب
          </span>
        </CButton>
        <CButton style="margin-right: 10px;" :disabled="whatsapp.id == 0" variant="outline" @click="testWhatsapp.show=true" color="dark">ارسال آزمایشی</CButton>
        <CButton 
            style="margin-right: 10px;"
            variant="outline" 
            @click="EditOrAddMessageModal(false)" 
            color="primary">
            افزودن پیام
        </CButton>
      </span>
    </div>

    <div class="whatsapp_warper">
      <div class="whatsapp_iner">
        <div class="whatsapp">
          <div class="message" v-for="(message, index) in whatsapp.data"  :key="index"
            draggable="true"   @dragover.prevent @dragstart="onDragStart(index)" @drop="onDrop(index)">
          
            
            <a v-if="message.type == 1 || message.type == 3" :href="message.url" target="_blank">
              <img style="margin-bottom: 7px;"  :src="message.urlResized" alt="">
            </a>
            <audio v-if="message.type == 2" controls>
              <source :src="message.url" type="audio/ogg">
            </audio>
            <video style="width: 100%;"  v-if="message.type == 4" controls>
              <source :src="message.url" type="video/mp4">
            </video>
            {{ message.message }}


            <span class="whatsapp_edit" @click="EditOrAddMessageModal(true,index,message);">ویرایش</span>
          </div>
        </div>
      </div>
    </div>

    <CModal
      :title="$t('whatsappTemplate.data.testWhatsapp.title')"
      color="info"
      size="lg"
      :show.sync="testWhatsapp.show"
    >
      <CRow>
        
        <CCol md="12">
          <CInput
            v-model="testWhatsapp.token"
            :label="$t('whatsappTemplate.data.testWhatsapp.token')"
            :placeholder="$t('whatsappTemplate.data.testWhatsapp.token')"
          />
        </CCol>
        <CCol md="12">
          <CTextarea
            id="testWhatsappList"
            v-model="testWhatsapp.list"
            :label="$t('whatsappTemplate.data.testWhatsapp.label')"
            :placeholder="$t('whatsappTemplate.data.testWhatsapp.placeholder')"
          />
        </CCol>
      </CRow>
      <br />
      <button
        slot="footer"
        type="button"
        class="btn btn-secondary"
        @click="testWhatsapp.show = false"
      >
        {{ $t("common.CANCEL") }}
      </button>
      <CButton
        slot="footer"
        type="button"
        class="btn btn-info"
        @click="sendTestWhatsapp()"
      >
        <CSpinner v-if="storeLoading" tag="span" size="md" />
        <CIcon v-if="!storeLoading" class="top_menu" name="cil-save" />
        <span v-if="!storeLoading">
          {{ $t("common.SEND") }}
        </span>
      </CButton>
    </CModal>

    <CModal
      :title="whatsappMessageTitle"
      color="info"
      size="sm"
      :show.sync="whatsappMessageModal"
    >
      <CRow>
        
        <CCol md="12">
          <CSelect
            :label="$t('whatsappTemplate.message.type.label')"
            :placeholder="$t('whatsappTemplate.message.type.placeholder')"
            :options="[
              { value: 0, label: $t('whatsappTemplate.message.type.0') },
              { value: 1, label: $t('whatsappTemplate.message.type.1') },
              { value: 2, label: $t('whatsappTemplate.message.type.2') },
              { value: 3, label: $t('whatsappTemplate.message.type.3') }
            ]"
            :value.sync="whatsappMessage.type"
          />
        </CCol>


        
        <CCol md="12" v-if="whatsappMessage.type!=0 && whatsappMessage.path != null">
          <a v-if="whatsappMessage.type == 1 || whatsappMessage.type == 3" :href="whatsappMessage.url" target="_blank">
            <img style="width: 100%;"  :src="whatsappMessage.urlResized" alt="">
          </a>
          <audio v-if="whatsappMessage.type == 2" controls style="width: 100%;">
              <source :src="whatsappMessage.url" type="audio/ogg">
          </audio>
          
          <video style="width: 100%;"  v-if="whatsappMessage.type == 4" controls>
              <source :src="whatsappMessage.url" type="video/mp4">
            </video>
          <span style="
              display: block;
              text-align: center;
              cursor: pointer;
              color: red;
              font-weight: bold;
          "  
          @click="whatsappMessage.path = null">حذف</span>
          <br>
        </CCol>
        <CCol md="12" v-if="whatsappMessage.type!=0 && whatsappMessage.path == null">
          <VueFileAgent
              ref="media"
              :multiple="false"
              :deletable="true"
              :meta="true"
              :linkable="true"
              :accept="'image/*, .ogg, video/*, application/pdf, .zip'"
              :maxSize="'25MB'"
              :maxFiles="1"
              :helpText="$t('ticket.attachment_helpText')"
              :errorText="{
                type: $t('ticket.attachment_error.type'),
                size: $t('ticket.attachment_error.size'),
              }"
              @upload="onUpload($event)"
              @select="filesSelected($event)"
              @beforedelete="onBeforeDelete($event,'media')"
              @delete="fileDeleted($event)"
              v-model="media"
            >
          </VueFileAgent>
        </CCol>

        <CCol md="12">
          <CTextarea
            v-if="whatsappMessage.type==0"
            v-model="whatsappMessage.message"
            rows="6"
            :label="$t('whatsappTemplate.message.text.label')"
            :placeholder="$t('whatsappTemplate.message.text.placeholder')"
          />
        </CCol>
        <CCol md="12">
          <CTextarea
            v-if="whatsappMessage.type!=0 && whatsappMessage.type!=2 && whatsappMessage.type!=4"
            v-model="whatsappMessage.message"
            rows="3"
            :label="$t('whatsappTemplate.message.caption.label')"
            :placeholder="$t('whatsappTemplate.message.caption.placeholder')"
          />
        </CCol>
        <CCol md="12" v-if="whatsappMessage.type!=2 && whatsappMessage.type!=4">
          <CAlert color="warning" closeButton>
            متغیر‌های قابل استفاده : 

            {employee_fullName}
            {employee_mobile}
            {employee_internal}
            {employee_email}            
            <span style="text-align: center;display: block;">---</span>
            {customer_fullName}
            {customer_brand}
            {customer_mobile}
            {customer_email}
            {customer_code}
            {customer_brand}
            {customer_timeToExpire}
          </CAlert>
        </CCol>
      </CRow>
      <br />
      <button
        slot="footer"
        type="button"
        class="btn btn-secondary"
        @click="whatsappMessageModal = false"
      >
        {{ $t("common.CANCEL") }}
      </button>
      <button
        v-if="whatsappMessage.index != null"
        slot="footer"
        type="button"
        class="btn btn-danger"
        @click="removeMessage"
      >
        {{ $t("common.DELETE") }}
      </button>
      <CButton
        slot="footer"
        type="button"
        class="btn btn-info"
        @click="saveMessage"
      >
        <CSpinner v-if="storeLoading" tag="span" size="md" />
        <CIcon v-if="!storeLoading" class="top_menu" name="cil-save" />
        <span v-if="!storeLoading">
          {{ $t("common.SAVE") }}
        </span>
      </CButton>
    </CModal>
  </div>
</template>

<script>

export default {
  name: "whatsapp",
  data() {
    return {
      uploadUrl: "https://api.hamkaran.cloud/api/v1/files-upload",
      uploadHeaders: {},
      fileRecordsForUpload: [],
      whatsappMessageTitle:null,
      whatsappMessageModal:false,
      media:null,
      whatsappMessage:{
        type:0,
        path:null,
        message:null,
      },
      testWhatsapp:{
        list:"09197511450",
        show:false,
        token:'',
        title:"تست قالب واتساپ",
        id:0,
      },
      show:false,
      storeLoading:false,
      whatsapp:{
        id:0,
        name: null,
        data: [] 
      },
      projectId: 0,
      tools: {
        image: {
          enabled: true,
        },
      },
      options: {
        fonts: {
          showDefaultFonts: true,
          customFonts: [
            {
              label: "Comic Sans",
              value: "'Comic Sans MS', cursive, sans-serif",
            },
            {
              label: "tahoma",
              value: "tahoma",
            },
            {
              label: "Vazir",
              value: "Vazirmatn",
              url: "https://fonts.googleapis.com/css?family=Vazirmatn:100,400,700",
            },
            {
              label: "Almarai",
              value: "Almarai",
              url: "https://fonts.googleapis.com/css?family=Almarai:100,400,700",
            },
          ],
        },
      },
      appearance: {
        theme: "dark",
        panels: {
          tools: {
            dock: "left",
          },
        },
      },
    };
  },
  mounted() {
    this.testWhatsapp.token=this.$store.state.data.wa_token;
    console.log(this.$route.params.prefix);
    if(this.$route.params.prefix){
     this.whatsapp.id=this.$route.params.prefix;
     this.getData();
    }else{
      this.show=true;
    }
  },
  methods: {
    filesSelected: function(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
        validFileRecords
      );
    },
    onBeforeDelete: function(fileRecord,type) {
      console.log(fileRecord);
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1);
        var k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else {
          this.$refs[type].deleteFileRecord(fileRecord); // will trigger 'delete' event
      }
    },
    fileDeleted: function(fileRecord) {
      console.log('fileDeleted');
    },

    storeData: function() {
      if (!this.storeLoading) {
        this.storeLoading = true;

        var token = localStorage.getItem("token");
        if (token)
          axios.defaults.headers.common.Authorization = "Bearer " + token;
        
        let formData=[];
        axios
          .post(
            "https://api.hamkaran.cloud/api/v1/admin/template/whatsapp",
            this.whatsapp
          )
          .then((response) => {
            this.storeLoading = false;
            this.whatsapp.id=response.data.data.id;
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: null,
                status: null,
                data: [],
              },
              successMessage: "save succes",
              successcount: count,
              errorcount: 0,
            };
            this.$store.commit("set", ["alert", alert]);
          })
          .catch((error) => {
            const count = this.$store.state.alert.errorcount + 1;
            console.log(error.response);
            this.storeLoading = false;
            const alert = {
              error_msg: {
                statusText: "خطا در ذخیره سازی",
                status: error.response.status,
                data: error.response.data,
              },
              successMessage: "",
              successcount: 0,
              errorcount: count,
            };
            this.$store.commit("set", ["alert", alert]);
          });
      }
    }, 
    
    sendTestWhatsapp: function() {
      if (!this.storeLoading) {
        this.storeLoading = true;

        var token = localStorage.getItem("token");
        if (token)
          axios.defaults.headers.common.Authorization = "Bearer " + token;
        this.testWhatsapp.id=this.whatsapp.id;
        let formData=[];
        axios
          .post(
            "https://api.hamkaran.cloud/api/v1/admin/template/test_whatsapp",
            this.testWhatsapp
          )
          .then((response) => {
            this.testWhatsapp.show = false;
            this.storeLoading = false;
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: null,
                status: null,
                data: [],
              },
              successMessage: "واتساپ با موفقعیت ارسال شد",
              successcount: count,
              errorcount: 0,
            };
            this.$store.commit("set", ["alert", alert]);
          })
          .catch((error) => {
            const count = this.$store.state.alert.errorcount + 1;
            console.log(error.response);
            this.storeLoading = false;
            this.testWhatsapp.show = false;
            const alert = {
              error_msg: {
                statusText: "خطا در ارسال واتساپ",
                status: error.response.status,
                data: error.response.data,
              },
              successMessage: "",
              successcount: 0,
              errorcount: count,
            };
            this.$store.commit("set", ["alert", alert]);
          });
      }
    }, 



    getData: function () {
        this.loading = true;
        var token = localStorage.getItem("token");
        if (token)
          axios.defaults.headers.common.Authorization = "Bearer " + token;

        axios
          .get(
            "https://api.hamkaran.cloud/api/v1/admin/template/whatsapp/" +this.whatsapp.id 
          )
          .then((response) => {
            this.loading = false;
            this.whatsapp=response.data.data;
            if(this.whatsapp.data == null){
              this.whatsapp.data=[];
            }else{
              this.whatsapp.data = JSON.parse(this.whatsapp.data);
            }
              
          })
          .catch((error) => {
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: "Eroor",
                status: "500",
                data: ["خطا بارگزاری اطلاعات"],
              },
              successMessage: "",
              successcount: 0,
              errorcount: count,
            };
            this.$store.commit("set", ["alert", alert]);
          });
    },


    EditOrAddMessageModal : function (isEdit,index,message) {
        if (!isEdit) {
          this.whatsappMessageTitle=this.$t('whatsappTemplate.edit_message');
          this.whatsappMessageModal=true;
          this.whatsappMessage={
            type:0,
            path:null,
            message:null,
            index:null
          };
        } else {
          this.whatsappMessageTitle=this.$t('whatsappTemplate.new_message');
          this.whatsappMessageModal=true;
          message.index=index;
          this.whatsappMessage=message;

          
        }
    },

    removeMessage : function () {
      this.whatsapp.data.splice(this.whatsappMessage.index, 1);
      this.whatsappMessageModal=false;
      this.storeLoading = false;
    },
    saveMessage : function () {
      if (!this.storeLoading) {
        this.storeLoading = true;
        if(this.fileRecordsForUpload.length == 0){
          let xx =this;
          if(xx.whatsappMessage.index != null){
            this.whatsapp.data[xx.whatsappMessage.index] = xx.whatsappMessage;
          }else{
            this.whatsapp.data.push(xx.whatsappMessage);
          }
          this.whatsappMessageModal=false;
          this.storeLoading = false;
          return '1';
        }
        // return this.saveData();
        this.$refs.media.upload(
          this.uploadUrl,
          this.uploadHeaders,
          this.fileRecordsForUpload
        );
        this.fileRecordsForUpload = [];
      }
    },

    
    onUpload(responses) {
      let xx =this;
      xx.whatsappMessage.urlResized =xx.media['upload']['data']['urlResized'];
      xx.whatsappMessage.path = xx.media['upload']['data']['name'];
      xx.whatsappMessage.url = xx.media['upload']['data']['url'];
      
      if(xx.whatsappMessage.index != null){
        this.whatsapp.data[xx.whatsappMessage.index] = xx.whatsappMessage;
      }else{
        this.whatsapp.data.push(xx.whatsappMessage);
      }
      
      this.whatsappMessageModal=false;
      this.storeLoading = false;
      xx.media=null;
    },

    onDragStart(index) {
        // زمانی که کاربر کشیده شروع کرد
        this.dragStartIndex = index;
    },
    onDrop(index) {
      if (this.dragStartIndex !== null && index !== this.dragStartIndex) {
        const draggedItem = this.whatsapp.data.splice(this.dragStartIndex, 1)[0];
        this.whatsapp.data.splice(index, 0, draggedItem);
        this.dragStartIndex = null;
      }
    },


  },


};
</script>
